import { document } from '@mtsbank/ui-kit'
import { getPreviousRoute } from '@root/hooks/usePreviousRoute'
import {
  actionGroups,
  buttonLocations,
  eventActions,
  eventCategories,
  eventContents,
  eventContexts,
  eventLabels,
  events,
  sendGmtEvent,
} from '../baseFunctions'
import { translit } from '../translit'

// Показ главной страницы
export const mainLoadedCyberGtm = () =>
  sendGmtEvent({
    event: events.mtsPageview,
    screenName: document.location.pathname,
    eventLabel: eventLabels.glavnaya,
    actionGroup: actionGroups.nonInteractions,
    eventCategory: eventCategories.igrovaya_stranica,
    ref: getPreviousRoute(),
  })

// Показ страницы новостей
export const newsCyberGtm = (providerName: string) =>
  sendGmtEvent({
    event: events.mtsPageview,
    screenName: document.location.pathname,
    eventAction: eventActions.screenShow,
    eventLabel: eventLabels.news,
    actionGroup: actionGroups.nonInteractions,
    eventCategory: eventCategories.igrovaya_stranica,
    productName: providerName,
    ref: getPreviousRoute(),
  })

// Показ страницы сервис недоступен
export const mainErrorCyberGtm = () =>
  sendGmtEvent({
    event: events.mtsPageview,
    screenName: document.location.pathname,
    eventLabel: eventLabels.glavnayaError,
    actionGroup: actionGroups.nonInteractions,
    eventCategory: eventCategories.igrovaya_stranica,
    ref: getPreviousRoute(),
  })

// Показ финального экрана
export const resultPageCyberGtm = () =>
  sendGmtEvent({
    event: events.mtsPageview,
    screenName: document.location.pathname,
    eventLabel: eventLabels.final,
    actionGroup: actionGroups.nonInteractions,
    eventCategory: eventCategories.igrovaya_stranica,
    ref: getPreviousRoute(),
  })

// Показ страницы сервиса
export const servicesLoadedCyberGtm = (providerName: string) =>
  sendGmtEvent({
    event: events.mtsPageview,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.screenShow,
    eventLabel: eventLabels.rekvizity,
    screenName: document.location.pathname,
    actionGroup: actionGroups.nonInteractions,
    productName: translit(providerName),
    ref: getPreviousRoute(),
  })

// Клик по баннеру в слайдере на главной странице
export const sliderMainClickGtm = (slideName: string) =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.bannerMain,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    productName: slideName,
    ref: getPreviousRoute(),
  })

// Клик по баннеру на финальной странице
export const bannerResultClickGtm = (bannerName: string) =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.bannerFinal,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    productName: bannerName,
    ref: getPreviousRoute(),
  })

// Ввод в поиске
export const searchChangeGtm = (search: string) =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formAdd,
    eventLabel: eventLabels.searchFormAdd,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    productName: search,
    ref: getPreviousRoute(),
  })

// Клик по сервису из поиска
export const serviceSearchClickGtm = (providerName: string) =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formAdd,
    eventLabel: eventLabels.serviceSearchForm,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    productName: translit(providerName),
    ref: getPreviousRoute(),
  })

// Клик по сервису из популярного
export const serviceTopClickGtm = (providerName: string) =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.servicePopular,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    productName: translit(providerName),
    ref: getPreviousRoute(),
  })

// Клик по сервису из категории пополнения игр
export const serviceClickGtm = (providerName: string) =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.serviceCatalog,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    productName: translit(providerName),
    ref: getPreviousRoute(),
  })

// Клик по табам
export const tabClickGtm = (title: string) =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.categoryChange,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    productName: title,
    ref: getPreviousRoute(),
  })

// Клик по новостям
export const newsClickGtm = (title: string) =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.newsClick,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    productName: title,
    ref: getPreviousRoute(),
  })

// Клик на ваучер\аккаунт
export const voucherAccountClickGtm = (nameButton: string) =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: translit(nameButton),
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
  })

// Передача поля login и email
export const loginOrEmailGtm = (nameService: string, loginOrEmail: string) =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formAdd,
    eventLabel: eventLabels.login,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    productName: translit(nameService),
    em: loginOrEmail,
    ref: getPreviousRoute(),
  })

// Передача поля login и email
export const loginOrEmailErrorGtm = (nameService: string) =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formAdd,
    eventLabel: eventLabels.loginMailError,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    productName: translit(nameService),
    ref: getPreviousRoute(),
  })

// Передача поля sum
export const sumGtm = (nameService: string, sum: string) =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formAdd,
    eventLabel: eventLabels.sum,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    CD1: sum,
    productName: translit(nameService),
    ref: getPreviousRoute(),
  })

// Клик на выбранный регион
export const countryClickGtm = (nameService: string, country: string) =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.region,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    CD1: country,
    productName: translit(nameService),
    ref: getPreviousRoute(),
  })

// Клик на выбранный ваучер
export const voucherSumClickGtm = (nameService: string, sum: string) =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.clickNaVaucher,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    CD1: sum,
    productName: translit(nameService),
    ref: getPreviousRoute(),
  })

// Клик на кнопку купить за
export const payClickGtm = (nameService: string, id: string, amount: string, paymentMethod: string) =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.kupit,
    eventContext: paymentMethod === 'SBP' ? eventContexts.SBP : eventContexts.MTS,
    eventValue: amount,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    filterName: id,
    productName: translit(nameService),
    ref: getPreviousRoute(),
    CD1: 'uspeh',
  })

// Клик на кнопку оформить карту
export const issueACardClickGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.oformitKartu,
    eventContent: eventContents.osnovnayaStranica,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
  })

// Клик на кнопку оформить карту на экране успеха СБП
export const issueACardSBPClickGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.oformitKartu,
    eventContent: eventContents.uspehSBP,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
  })

// Передача поля номер карты
// export const cardNumberGtm = () =>
//   sendGmtEvent({
//     event: events.mtsPaymentSpa,
//     eventCategory: eventCategories.igrovaya_stranica,
//     eventAction: eventActions.formAdd,
//     eventLabel: eventLabels.nomerKarty,
//     screenName: document.location.pathname,
//     actionGroup: actionGroups.interactions,
//   })

// Передача поля срок действия карты
// export const cardDateGtm = () =>
//   sendGmtEvent({
//     event: events.mtsPaymentSpa,
//     eventCategory: eventCategories.igrovaya_stranica,
//     eventAction: eventActions.formAdd,
//     eventLabel: eventLabels.srokDeistviyaKarty,
//     screenName: document.location.pathname,
//     actionGroup: actionGroups.interactions,
//   })

// Передача поля код карты
// export const cardCvcGtm = () =>
//   sendGmtEvent({
//     event: events.mtsPaymentSpa,
//     eventCategory: eventCategories.igrovaya_stranica,
//     eventAction: eventActions.formAdd,
//     eventLabel: eventLabels.kodKarty,
//     screenName: document.location.pathname,
//     actionGroup: actionGroups.interactions,
//   })

// Клик на кнопку оплатить
// export const paymentClickGtm = () =>
//   sendGmtEvent({
//     event: events.mtsPaymentSpa,
//     eventCategory: eventCategories.igrovaya_stranica,
//     eventAction: eventActions.buttonClick,
//     eventLabel: eventLabels.oplatit,
//     eventContext: eventContexts.cardMTS,
//     screenName: document.location.pathname,
//     actionGroup: actionGroups.interactions,
//   })

// Экран успешной оплаты
export const sucssesOplataGtm = (nameService: string, id: string, sbp?: boolean) =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formConfirm,
    eventLabel: eventLabels.platezhOtpravlen,
    eventContext: sbp ? eventContexts.SBP : eventContexts.MTS,
    screenName: document.location.pathname,
    actionGroup: actionGroups.conversions,
    filterName: id,
    productName: translit(nameService),
    ref: getPreviousRoute(),
  })

// Экран обработки платежа
export const waitedOplataGtm = (nameService: string, id: string, sbp?: boolean) =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formConfirm,
    eventLabel: eventLabels.platezhVobrabotke,
    eventContext: sbp ? eventContexts.SBP : eventContexts.MTS,
    screenName: document.location.pathname,
    actionGroup: actionGroups.conversions,
    filterName: id,
    productName: translit(nameService),
    ref: getPreviousRoute(),
  })

// Экран неуспеха
export const rejectedOplataGtm = (id: string, sbp?: boolean) =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formRejected,
    eventLabel: eventLabels.platezhNeOtpravlen,
    eventContext: sbp ? eventContexts.SBP : eventContexts.MTS,
    screenName: document.location.pathname,
    actionGroup: actionGroups.conversions,
    filterName: id,
    ref: getPreviousRoute(),
  })

// Экран успешной оплаты мтс карта
export const sucssesMTSCardGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formConfirm,
    eventLabel: eventLabels.platezhOtpravlen,
    eventContext: eventContexts.cardMTS,
    screenName: document.location.pathname,
    actionGroup: actionGroups.conversions,
    ref: getPreviousRoute(),
  })

// Экран неуспешной оплаты мтс карта
export const rejectedMTSCardGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formRejected,
    eventLabel: eventLabels.platezhNeOtpravlen,
    eventContext: eventContexts.cardMTS,
    screenName: document.location.pathname,
    actionGroup: actionGroups.conversions,
    ref: getPreviousRoute(),
  })

// Экран недостаточно средств мтс карта
export const noMoneyMTSCardGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formRejected,
    eventLabel: eventLabels.nedostatochnoSredstv,
    eventContext: eventContexts.cardMTS,
    screenName: document.location.pathname,
    actionGroup: actionGroups.conversions,
    ref: getPreviousRoute(),
  })

// Клик по сервису
export const bannerClickGtm = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.podrobnee,
    eventContext: eventContexts.nachniIgru,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
  })

// Клик на главную
export const homeClickGtm = (nameService?: string) =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.toMainPage,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    productName: translit(nameService),
    ref: getPreviousRoute(),
  })

// Клик на кнопку принять участие
export const promoButtonClickGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.prinyatUchastie,
    eventContext: eventContexts.promoInarius,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
  })

// Заполение телефона
export const phoneGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formAdd,
    eventLabel: eventLabels.nomerTelefona,
    eventContext: eventContexts.promoInarius,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    // productName: translit(nameService),
    // em: loginOrEmail,
    ref: getPreviousRoute(),
  })

// Экран успешной регистрации
export const sucssesPromoRegGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formConfirm,
    eventLabel: eventLabels.uchastnikRozigrisha,
    eventContext: eventContexts.promoInarius,
    screenName: document.location.pathname,
    actionGroup: actionGroups.conversions,
    ref: getPreviousRoute(),
  })

// Клик на кнопку пополнить акк на промо странице
export const payAccClickGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.popolnitAkkaunt,
    eventContext: eventContexts.promoInarius,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
  })

// Клик на кнопку пополнить акк в модалке
export const payAccPopUpClickGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.popolnitAkkaunt,
    eventContext: eventContexts.popUpPromoInarius,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
  })

// Показ формы заполения телефона
export const phoneFormShowGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formShow,
    eventLabel: eventLabels.promoInarius,
    screenName: document.location.pathname,
    actionGroup: actionGroups.conversions,
    ref: getPreviousRoute(),
  })

// Клик на кнопку Оформить в шапке
export const designButtonHeaderClickGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.oformitKartu,
    productName: 'mts_cashback_lite_mir',
    productId: 'vc_cashback_lite_mir',
    buttonLocation: buttonLocations.header,
    screenName: document.location.pathname,
    actionGroup: actionGroups.conversions,
    ref: getPreviousRoute(),
  })

// Клик на кнопку Оформить в футоре
export const designButtonFooterClickGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.oformitKartu,
    productName: 'mts_cashback_lite_mir',
    productId: 'vc_cashback_lite_mir',
    buttonLocation: buttonLocations.footer,
    screenName: document.location.pathname,
    actionGroup: actionGroups.conversions,
    ref: getPreviousRoute(),
  })

// Клик на кнопку Оформить в футоре
export const FullTermsClickGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.pravilaAkciiKeshbekZaIgry,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
  })

// Клик на виджет
export const WidgetClickGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.vidzhetKeshbek30,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
  })

// Клик на кнопку индивидуального заказа
export const individualOrderClickGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.bannerClick,
    eventLabel: eventLabels.individZakaz,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
  })
